module.exports = __webpack_public_path__ + "img/intact.b1bc8c7d.svg";